import { ColorEnum } from '@/constants/color'
import Pill from '@/features/ui/components/Pill'
import { FC } from 'react'
import { StyleSheet } from 'react-native'

interface LabelProps {
    children: string
    color?: string
}

const Label: FC<LabelProps> = ({ children, color }) => {
    return (
        <Pill style={[styles.label, { backgroundColor: color ?? ColorEnum.BLUE_500 }]}>
            {children}
        </Pill>
    )
}

const styles = StyleSheet.create({
    label: {
        borderTopLeftRadius: 8,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 8,
        height: 24,
    },
})

export default Label
